import { render, staticRenderFns } from "./StatusSummaryList.vue?vue&type=template&id=564073d7&scoped=true&"
import script from "./StatusSummaryList.vue?vue&type=script&lang=ts&"
export * from "./StatusSummaryList.vue?vue&type=script&lang=ts&"
import style0 from "./StatusSummaryList.vue?vue&type=style&index=0&id=564073d7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564073d7",
  null
  
)

export default component.exports